import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  {
    id: 1,
    content: "Finease transformed our financial operations. Their CFO services helped us close our Series B with confidence. The team's expertise in startup finance is unmatched.",
    author: "Sarah Chen",
    role: "CEO",
    company: "TechFlow AI",
    rating: 5,
  },
  {
    id: 2,
    content: "The strategic tax planning saved us over ₹2Cr in our first year. Their proactive approach to wealth preservation has been invaluable for our growth.",
    author: "Marcus Rodriguez",
    role: "Founder",
    company: "Nexus Health",
    rating: 5,
  },
  {
    id: 3,
    content: "Working with Finease on our fundraising strategy was a game-changer. They helped us structure our pitch and financials perfectly for investor conversations.",
    author: "Emily Watson",
    role: "Co-Founder",
    company: "GreenScale",
    rating: 5,
  },
];

export const TestimonialsSection = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="text-xs font-mono tracking-wider uppercase text-[#00C896]/80 mb-4 block">
            Testimonials
          </span>
          <h2
            className="text-4xl md:text-5xl font-semibold tracking-tight text-white mb-6"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Trusted by Industry Leaders
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            Hear from founders and executives who have transformed their 
            financial strategy with Finease.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="testimonial-card bg-[#0A0A0A] rounded-2xl p-8 border border-white/5 hover:border-[#00C896]/20 transition-colors"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    className="fill-[#00C896] text-[#00C896]"
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-slate-300 leading-relaxed mb-8 relative z-10">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[#00C896]/20 flex items-center justify-center">
                  <span className="text-[#00C896] font-semibold">
                    {testimonial.author.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-white font-medium">{testimonial.author}</p>
                  <p className="text-sm text-slate-500">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
